import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { validators } from '../../../utils/helpers/validators'
import { MineturPricesService } from '../../../services/prices-fuel-stations/pricesFuelStations.service'
import useInputs from '../../../utils/hooks/useInputs'
import SaveButton from '../../common/buttons/SaveButton'
import { parseStringDateToISOString } from '../../../utils/helpers/date'
import FillPrices from './price-changes/FillPrices'
import GasStationChangeDate from './price-changes/GasStationChangeDate'
import LastNotifiedPrices from './LastNotifiedPrices'
import NotifiedToPricesAllGasStation from './price-changes/NotifiedToPricesAllGasStation'
import './changePriceForm.scss'

const ChangePriceForm = ({ handleSubmit, ownStationId }) => {
  const initialStateInputs = { AdBlue: '', G95: '', GOAPLUS: '', GOA: '' }

  const { inputs, onChangeInputs, updateInputs } = useInputs(initialStateInputs)

  const [prices, setPrices] = useState([])
  const [latestPrices, setLatestPrices] = useState([])
  const [ownFuelStationDisabled, setOwnFuelStationDisabled] = useState([])
  const [disableSaveButton, setDisableButton] = useState(true)

  useEffect(() => {
    if (inputs?.ownStation || ownStationId) {
      getCenterPrices()
    }
  }, [inputs?.ownStation])

  useEffect(() => {}, [disableSaveButton])

  const getCenterPrices = async () => {
    const resp = await MineturPricesService.getLastPriceCenter(
      inputs?.ownStation?._id || ownStationId,
    )
    if (resp) {
      setLatestPrices(resp?.resp)
      const initLastPrices = {
        AdBlue: resp?.resp[0]?.prices?.AdBlue || '',
        G95: resp?.resp[0]?.prices?.G95 || '',
        GOAPLUS: resp?.resp[0]?.prices?.GOAPLUS || '',
        GOA: resp?.resp[0]?.prices?.GOA || '',
      }
      updateInputs({ ...inputs, ...initLastPrices })
    }
  }

  const parseFloatPrices = Object.fromEntries(
    Object.entries(_.omit(inputs, 'ownStation', 'changeDate'))
      .filter(([price, value]) => value !== '')
      .map(([price, value]) => [price, value]),
  )

  const sendToChangePrice = async () => {
    setDisableButton(false)
    const sendPrices = ownStationId
      ? [
          {
            ownStation: ownStationId,
            prices: parseFloatPrices,
            changeDate: parseStringDateToISOString(inputs?.changeDate),
          },
        ]
      : prices.map((x) => ({
          ...x,
          ownStation: x?.ownStation?._id,
          changeDate: parseStringDateToISOString(x?.changeDate),
        }))

    const response = await MineturPricesService.addPrice({
      priceList: sendPrices,
    })
    if (response) {
      updateInputs(initialStateInputs)
      handleSubmit()
    }
    setDisableButton(true)
  }

  const addCenterPrice = () => {
    const dataPrices = parseFloatPrices
    const date = inputs?.changeDate
      ? inputs?.changeDate
      : new Date(new Date().getTime() + 90 * 60000) //add 90 min
    setPrices([
      ...prices,
      { ownStation: inputs?.ownStation, prices: dataPrices, changeDate: date },
    ])
    setOwnFuelStationDisabled([
      ...ownFuelStationDisabled,
      inputs.ownStation?._id,
    ])
    updateInputs(initialStateInputs)
    setLatestPrices([])
  }

  const removeItemCenterPrice = (item) => {
    setPrices(
      prices.filter((x) => x?.ownStation?._id !== item?.ownStation?._id),
    )
    setOwnFuelStationDisabled(
      ownFuelStationDisabled.filter((x) => x !== item?.ownStation?._id),
    )
  }

  const validateForm = validators.isEntityValues([
    inputs?.ownStation,
    inputs?.GOA,
    inputs?.G95,
  ])

  return (
    <div className="fuelstations-settings-container">
      <div className="fuelstations-settings-content modal-content-wrapper">
        <div className="wrapper-flex ">
          <div className="wrapper-flex__content">
            <GasStationChangeDate
              inputs={inputs}
              onChangeInputs={onChangeInputs}
              ownFuelStationDisabled={ownFuelStationDisabled}
            />
          </div>

          <div className="flex-container">
            <FillPrices inputs={inputs} onChangeInputs={onChangeInputs} />
          </div>
        </div>

        <div className="wrapper-flex ">
          <div className="flex-container ">
            <LastNotifiedPrices latestPrices={latestPrices} />
          </div>
          {!ownStationId && (
            <div className="flex-container ">
              <NotifiedToPricesAllGasStation
                prices={prices}
                removeItemCenterPrice={removeItemCenterPrice}
              />
            </div>
          )}
        </div>
      </div>

      <div className="modal-btn-container">
        {!ownStationId && (
          <SaveButton
            btnText="button.add"
            btnClass="btn__transparent mr__05"
            isDisabled={!validateForm}
            onClick={() => addCenterPrice()}
          />
        )}
        <SaveButton
          btnText="button.send.prices"
          btnClass="btn-save-modal"
          isDisabled={
            !(
              (ownStationId ? validateForm : prices.length > 0) &&
              disableSaveButton
            )
          }
          onClick={() => sendToChangePrice()}
        />
      </div>
    </div>
  )
}

export default ChangePriceForm
